// The `edition` attribute on a child journal — which year of the child's life it
// covers. The client owns this value (set on create/update); the server only
// stores, validates and reports it back. See docs/child_journal_editions.md.
export const EDITIONS = [
  { value: 'first_year', label: '1st Year' },
  { value: 'second_year', label: '2nd Year' },
  { value: 'third_year', label: '3rd Year' },
  { value: 'fourth_year', label: '4th Year' },
  { value: 'fifth_year', label: '5th Year' },
];

const EDITION_LABELS = Object.fromEntries(EDITIONS.map(({ value, label }) => [value, label]));

export const editionLabel = value => EDITION_LABELS[value] || null;
